import useI18n from '@/shared/hooks/usei18n'
import { DataBlock } from '@/common'
import { SupplierEmissionsReport } from '@/features/suppliers/hooks/supplierEmissionsReport'
import ReactCountryFlag from 'react-country-flag'

export default function CbamSimulationGoodDataSection({
  supplierEmissionsReportId,
  selectedSupplierEmissionsReport,
  defaultSpecificDirectEmbeddedEmissions,
  defaultSpecificIndirectEmbeddedEmissions,
  installationCountry,
  simulationYear
}: {
  supplierEmissionsReportId?: string | null
  selectedSupplierEmissionsReport?: SupplierEmissionsReport
  defaultSpecificDirectEmbeddedEmissions?: number | null
  defaultSpecificIndirectEmbeddedEmissions?: number | null
  installationCountry?: string | null
  simulationYear: number
}) {
  const { t, numberFormatter3Decimals } = useI18n()

  return (
    <>
      {supplierEmissionsReportId && (
        <div className="space-y-4">
          <div>
            <DataBlock
              label={t(
                'cbamSimulations:cbamSimulationDetails.dialogs.simulationGood.dataBlocks.supplierCountry'
              )}
              data={
                <>
                  <ReactCountryFlag countryCode={installationCountry || ''} svg />{' '}
                  <span>{t(`common:countriesByIsoAlpha2:${installationCountry}`)}</span>
                </>
              }
            />
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <DataBlock
              label={t(
                'cbamSimulations:cbamSimulationDetails.dialogs.simulationGood.dataBlocks.specificDirectEmbeddedEmissions'
              )}
              data={`${numberFormatter3Decimals(selectedSupplierEmissionsReport?.specificDirectEmbeddedEmissions ?? 0)} tCO₂e/t`}
            />
            <DataBlock
              label={t(
                'cbamSimulations:cbamSimulationDetails.dialogs.simulationGood.dataBlocks.specificIndirectEmbeddedEmissions'
              )}
              data={`${numberFormatter3Decimals(selectedSupplierEmissionsReport?.specificIndirectEmbeddedEmissions ?? 0)} tCO₂e/t`}
            />
          </div>
        </div>
      )}
      {defaultSpecificDirectEmbeddedEmissions !== undefined &&
        defaultSpecificIndirectEmbeddedEmissions !== undefined &&
        selectedSupplierEmissionsReport === undefined && (
          <div className="grid sm:grid-cols-2 gap-4">
            <DataBlock
              label={t(
                'cbamSimulations:cbamSimulationDetails.dialogs.simulationGood.dataBlocks.defaultSpecificDirectEmbeddedEmissions',
                {
                  year: simulationYear
                }
              )}
              data={`${numberFormatter3Decimals(defaultSpecificDirectEmbeddedEmissions ?? 0)} tCO₂e/t`}
            />
            <DataBlock
              label={t(
                'cbamSimulations:cbamSimulationDetails.dialogs.simulationGood.dataBlocks.defaultSpecificIndirectEmbeddedEmissions',
                {
                  year: simulationYear
                }
              )}
              data={`${numberFormatter3Decimals(defaultSpecificIndirectEmbeddedEmissions ?? 0)} tCO₂e/t`}
            />
          </div>
        )}
    </>
  )
}
